// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zoyumn0 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n.zoyumn1 {\n  margin: 2px 0 0 0;\n  width: 100%;\n  max-width: 846px;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
